import React from "react";
import { graphql, Link } from "gatsby";
import styled from "styled-components";
import Layout from "../components/layout";
import Seo from "../components/seo";
import { Section, Container, SectionPageTitle, SectionDescription, SectionTitle, ExploreMore, BreadCrumb } from "../components/Section";
import PrimaryButton from "../components/Button/PrimaryButton";
import ProductCardGridView from "../components/ProductCardGridView";
import slugify from "slugify";

const ProductGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px 0px;
  @media (min-width: 992px) {
    margin: 0 -15px 0px;
  }
`;
const ProductGridItem = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
  @media (min-width: 768px) {
    max-width: 50%;
    flex: 0 0 50%;
  }
  @media (min-width: 1200px) {
    max-width: 33.333333%;
    flex: 0 0 33.333333%;
  }
`;

const CityTemplate = ({ location, data, pageContext }) => {
  const allProducts = data.allContentfulProduct.edges;
  const { stateName, stateNameAbbreviation, cityName, stateSlug, deliveryLocationContent } = pageContext;
  let deliveryLocationContentHTML = deliveryLocationContent?.childMarkdownRemark.html;
  deliveryLocationContentHTML = deliveryLocationContentHTML?.replaceAll("{CITY}", cityName);
  deliveryLocationContentHTML = deliveryLocationContentHTML?.replaceAll("{STATE}", stateName);

  const breadcrumbSchema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.engineeredmetalbuildings.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": stateName,
        "item": `https://www.engineeredmetalbuildings.com/${slugify(stateName.toLowerCase())}/`
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": cityName
      }
    ],
  };
  const schema = [breadcrumbSchema];

  return (
    <Layout location={location}>
      <Seo
        title={`Metal Buildings in ${cityName}, ${stateName} | Prefab Garages, Barns & Carports`}
        description={`Buy pre-engineered metal buildings in ${cityName}, ${stateNameAbbreviation || stateName}, carports, garages, barns, and more. Easy online ordering, fast delivery, and expert installation for any project.`}
        schemaMarkup={schema}
      />
      <Section
        ept="180px"
        epb="60px"
        xpt="140px"
        xpb="40px"
        pt="130px"
        pb="30px"
        bgColor="#fff"
        className="section-city"
      >
        <Container>
          <BreadCrumb className="black">
            <Link to="/">Home</Link>
            <Link to={`/${stateSlug}`}>{stateName}</Link>
            <span>{cityName}</span>
          </BreadCrumb>
          <SectionPageTitle textAlign="center">Metal Buildings {cityName}, {stateName}</SectionPageTitle>
          {deliveryLocationContent &&
            <SectionDescription
              mb="0"
              textAlign="center"
              dangerouslySetInnerHTML={{ __html: deliveryLocationContentHTML }}
            />
          }
        </Container>
      </Section>
      <Section
        ept="60px"
        epb="60px"
        xpt="40px"
        xpb="40px"
        pt="30px"
        pb="30px"
        bgColor="#eef0fd"
        className="section-product"
      >
        <Container>
          <SectionTitle textAlign="center">Explore Our Top Selling Products {cityName}, {stateName}</SectionTitle>
          <ProductGrid>
            {allProducts.map((item, i) =>
              <ProductGridItem key={i}>
                <ProductCardGridView product={item.node} />
              </ProductGridItem>
            )}
          </ProductGrid>
          <ExploreMore mt="30px"><Link to="/shop"><PrimaryButton text="View All" /></Link></ExploreMore>
        </Container>
      </Section>
    </Layout>
  );
};
export default CityTemplate;

export const pageQuery = graphql`
  query CityTemplatePageQuery {
    allContentfulProduct(
      limit: 24
      sort: { fields: skuNumber, order: ASC }
    ) {
      edges {
        node {
          id
          url
          rto
          financingAvailable
          skuNumber
          title
          image {
            gatsbyImageData(quality: 50, placeholder: BLURRED)
            fluid {
              srcWebp
            }
          }
          price
          width
          length
          height
          city
          state
          zipcode
          location {
            lat
            lon
          }
          buildingCondition
          description {
            childMarkdownRemark {
              html
            }
          }
          specifications {
            childMarkdownRemark {
              html
            }
          }
          productCategories {
            title
          }
          buildingTags
          roofStyleType
          manufacturer
          gaugeTubing
          gaugePanels
        }
      }
    }
  }
`;
